module.exports = __webpack_public_path__ + "img/hr-branch-particle-03.5d6a0ecc.png";